"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _utils = require("./utils");

var _default = (0, _createReactClass.default)({
  displayName: "FormattedReactMessage",
  mixins: [_utils.I18nCommonMixin],
  propTypes: _utils.commonPropTypes,
  getEscapedParam: function getEscapedParam(param, key, index) {
    if (!_react.default.isValidElement(key)) {
      return _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: _I18n.default.formatParam(param, key)
        },
        key: param + "-" + index
      });
    }

    return _react.default.cloneElement(key, {
      key: param + "-" + index,
      ref: key.ref
    });
  },
  renderFormattedMessage: function renderFormattedMessage() {
    return _I18n.default.interpolateToArray(this.props.message, this.props.options, this.getEscapedParam);
  },
  render: function render() {
    var props = (0, _utils.getPassThroughProps)(this.props);
    return _react.default.createElement("span", props, this.renderFormattedMessage());
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.554/js/components/FormattedReactMessage.js
// module id = 65
// module chunks = 0